import MegaMenu from '../mega-menu/mega-menu.js';
class SearchIcon extends HTMLElement {
  connectedCallback() {
    this.initVariables();
    this.initEventListeners();
  }

  initVariables() {
    this.searchToggleElement = this.querySelector('[data-search-icon]');
    this.predictiveSearchBar = document.querySelector(
      '[data-predictive-search-bar]'
    );
    this.predictiveSearchInput = document.querySelector(
      '[data-predictive-search-input]'
    );
  }

  /**
   * Initializes the event listeners
   * @return {void}
   */
  initEventListeners() {
    this.addEventListener('click', () => {
      this.toggleSearchInput();
      this.predictiveSearchInput.focus();
      this.fadeIcon();
      this.closePredictiveSearchResults();
    });
  }

  /**
   * Toggle the search input
   */
  toggleSearchInput() {
    // If its not the search page, we hide the predictive search bar
    if (globalThis.location.pathname !== '/search') {
      this.predictiveSearchBar.classList.toggle('active');
    }

    if (this.predictiveSearchBar.classList.contains('active')) {
      MegaMenu.closeMegaMenu();
      document.body.classList.add('predictive-search-bar-open');
    } else {
      document.body.classList.remove('predictive-search-bar-open');
    }
  }

  /**
   * After the open search bar animation is complete, give the input focus
   */
  setInputFocusListener() {
    this.predictiveSearchBar.addEventListener('transitionend', () => {
      if (this.predictiveSearchBar.classList.contains('active')) {
        this.predictiveSearchInput.focus();
      }
    });
  }

  /**
   * Fade the icon
   */
  fadeIcon() {
    if (globalThis.location.pathname !== '/search') {
      this.searchToggleElement.classList.toggle('fade');
    }
  }

  /**
   * Close the predictive search results
   */
  closePredictiveSearchResults() {
    // If the predictive search results have been expanded, also close out
    const predictiveSearchResults = document.querySelector(
      '[data-predictive-search-results]'
    );
    if (predictiveSearchResults) {
      predictiveSearchResults.close();
    }
  }
}

customElements.get('search-icon') ||
  customElements.define('search-icon', SearchIcon);
